const osDetect = () => {
  /* eslint-disable */
  const userAgent = window.navigator.userAgent;
  /* eslint-enable */
  let OS = '';
  if (userAgent.indexOf('Mac') > -1) {
    OS = 'mac';
  }
  if (userAgent.indexOf('iPhone') > -1) {
    OS = 'ios';
  }
  if (userAgent.indexOf('Win') > -1) {
    OS = 'win';
  }
  if (userAgent.indexOf('Linux') > -1) {
    OS = 'linux';
  }
  document.querySelector('html').classList.add(OS);
};
export default osDetect;



// WEBPACK FOOTER //
// ./src/scripts/modules/os-detect.js